import React from 'react';
import { Link } from 'react-router-dom';
import { FaCog, FaPhone, FaEnvelope, FaClock, FaGlobe } from 'react-icons/fa';
import { CONTACT, phoneHref } from '../constants/contact';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <FaCog className="footer-logo-icon" />
              <div>
                <span className="fl-main">MaxAutoParts</span>
                <span className="fl-sub">by Opulence Technologies</span>
              </div>
            </Link>
            <p>Your trusted source for OEM auto parts at prices up to 30% less than dealerships. Quality, reliability, and savings — powered by <strong style={{color:'#FFA500'}}>Opulence Technologies</strong> at <strong style={{color:'#FFA500'}}>maxautoparts.online</strong>.</p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/#products">Products</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Policy</h4>
            <ul>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Us</h4>
            <div className="footer-contact">
              <div className="fc-item">
                <FaPhone className="fc-icon" />
                <div>
                  <strong>Phone</strong>
                  <a href={phoneHref}>{CONTACT.phone}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaEnvelope className="fc-icon" />
                <div>
                  <strong>Email</strong>
                  <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaGlobe className="fc-icon" />
                <div>
                  <strong>Website</strong>
                  <a href={CONTACT.websiteUrl} target="_blank" rel="noreferrer">{CONTACT.website}</a>
                </div>
              </div>
              <div className="fc-item">
                <FaClock className="fc-icon" />
                <div>
                  <strong>Hours</strong>
                  <span>Mon–Fri: 8AM–8PM EST</span>
                  <span>Sat: 9AM–5PM EST</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container footer-bottom-inner">
          <p>&copy; 2026 Opulence Technologies. All rights reserved. | MaxAutoParts &mdash; maxautoparts.online</p>
          <div className="footer-links">
            <Link to="/contact-us">Contact Us</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms and Conditions</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
